<div class="row">
    <div class="col-lg-12">
        <div class="card">
            <div class="card-body">
                <div class="faq-section">
                    <div class="container-fluid bg-success py-2">
                        <p class="mb-0 text-white">{{ 'faq' | localise }}</p>
                    </div>
                    <ngb-accordion class="accordion" [closeOthers]="true" activeIds="panel-0">
                        <ngb-panel *ngFor="let faq of faqs; let i = index" id="panel-{{ i }}" [title]="faq.question">
                            <ng-template ngbPanelContent>
                                <div class="mb-0" [innerHTML]="faq.answer"></div>
                            </ng-template>
                        </ngb-panel>
                    </ngb-accordion>
                </div>
            </div>
        </div>
    </div>
</div>
